import SingleStepNotification from './single-step-notification'

export default class StepDoneNotification extends SingleStepNotification {
  constructor(transfer, filter) {
    super(transfer, filter)
    this.name = 'StepDone'
    this.filterEventId = 'STEP_DONE'

    if (filter) {
      this.channelName = this.filter.channelName

      const signature = this.filter.signature
      this.attachedStepId = signature ? signature.stepId : null
    }
  }

  get predicateConfigs() {
    return [true]
  }

  get summaryText() {
    const stepName = this.formatConfigurable(this.attachedStep.name)
    const channel = this.formatConfigurable(this.friendlyChannelName)
    return `If the ${stepName} is completed, inform me via ${channel}.`
  }

  get message() {
    if (this.channelName === 'TWILIO_CALL')
      return '<Response> <Say voice="alice" language="en-US"> <Pause length="3"/> Hello. This is the automatic Sender call service. This is a progress report regarding the transfer {{ transfer_name }} to inform you that the {{ step_name }} has been reached. Thank you for working with us. Your sender team. </Say> </Response>'
    return 'This is an automatic sennder system progress report for the transfer {{ transfer_name }}. The {{ step_name }} has been completed.'
  }
}
